import { render, staticRenderFns } from "./StudentGrades.vue?vue&type=template&id=5c300883"
import script from "./StudentGrades.vue?vue&type=script&lang=js"
export * from "./StudentGrades.vue?vue&type=script&lang=js"
import style0 from "./StudentGrades.vue?vue&type=style&index=0&id=5c300883&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports